class MatchAddShotsController {
	constructor(MatchesFactory, $rootScope, $filter, $state){
		'ngInject';
		const vm = this;

		let $translate = $filter('translate');

		vm.rootScope = $rootScope;
		vm.$onInit = () =>{
			$state.current.data.hideSidebar = true;
			$state.current.data.hideMatchProfile = true;
			$state.current.data.hideMatchMenu = true;
			vm.activeRoundIdentifier = 1;
			vm.activeTargetNumber = null;
			vm.shots = {};
			vm.targetNumbers = [];
			vm.activeMatchPlayers = [];
			vm.shotsHeaders = [
				{name: '#', class: 'col-xs-1'},
				{name: 'Βέλος 1ο', class: 'col-xs-2'},
				{name: 'Βέλος 2ο', class: 'col-xs-2'},
				{name: 'Βέλος 3ο', class: 'col-xs-2'},
				{name: 'Shot', class: 'col-xs-1'},
				{name: 'Inc.', class: 'col-xs-1'},
				{name: 'Χs', class: 'col-xs-1'},
				{name: '10s', class: 'col-xs-1'},
				{name: '9s', class: 'col-xs-1'},
			];
			vm.maxShots = 13;
			if(vm.rootScope.currentMatch.match_type === MatchesFactory.MATCH_TYPES.INDOOR){
				vm.maxShots = 11;
			}
			vm.moveToNextTarget = false;
			reloadMatchData();
		};

		vm.selectRound = (identifier) =>{
			vm.activeRoundIdentifier = identifier;
			if(vm.activeMatchPlayer){
				reloadRound();
			}
		};
		vm.selectTargetNumber = () =>{
			vm.activeMatchPlayers = [];
			Object.entries(vm.matchPlayers).forEach(entry =>{
				let value = entry[1];
				if(value.targetNumber !== vm.activeTargetNumber){ return;}
				vm.activeMatchPlayers.push(value);
			});
		};
		vm.selectMatchPlayer = (matchPlayerId) =>{
			let params = {match_player_id: matchPlayerId, include: 'matchPlayers,matchPlayers.rounds'};
			MatchesFactory.getOne(vm.rootScope.currentMatchId, params).then(response =>{
				vm.activeMatchPlayer = response.data.matchPlayers[0];
				reloadRound();
			});
		};
		vm.addShots = () =>{
			let shots = {};
			for(let i = 1; i < vm.maxShots; i++){
				shots[i] = vm.shots[i].arrows;
			}
			MatchesFactory.addShots(vm.activeRound.round_id, {shots: shots}).then(response =>{
				let activeMatchPlayerId = vm.activeMatchPlayer.match_player_id;
				let currentIndex = vm.matchPlayers.findIndex(matchPlayer =>{
					return matchPlayer.match_player_id === activeMatchPlayerId;
				});
				let nextMatchPlayer = vm.matchPlayers[currentIndex + 1];
				if(!nextMatchPlayer){return;}
				if(vm.activeTargetNumber !== nextMatchPlayer.targetNumber){
					vm.activeTargetNumber = nextMatchPlayer.targetNumber;
				}
				vm.selectTargetNumber();
				vm.selectMatchPlayer(nextMatchPlayer.match_player_id);
			});
		};
		vm.clearRoundShots = () =>{
			MatchesFactory.clear(vm.activeRound.round_id).then(response =>{
				vm.selectMatchPlayer(vm.activeMatchPlayer.match_player_id);
			});
		};
		vm.calculateArrows = () =>{
			for(let i = 1; i < vm.maxShots; i++){
				let shotScore = 0;
				let nines = 0;
				let xs = 0;
				let tens = 0;
				for(let j = 1; j < 4; j++){
					if(!vm.shots[i].arrows[j]){ continue; }
					if(parseInt(vm.shots[i].arrows[j]) === 10){ tens++; }
					if(parseInt(vm.shots[i].arrows[j]) === 9){ nines++; }
					if(parseInt(vm.shots[i].arrows[j]) === 0){ vm.shots[i].arrows[j] = 'm'; }
					if(parseInt(vm.shots[i].arrows[j]) === 11){ vm.shots[i].arrows[j] = 'x'; }
					if(vm.shots[i].arrows[j].toLowerCase() === 'x'){
						xs++;
						tens++;
						shotScore += 10;
					}

					if(vm.shots[i].arrows[j].toLowerCase() !== 'm' && vm.shots[i].arrows[j].toLowerCase() !== 'x'){
						shotScore = shotScore + parseInt(vm.shots[i].arrows[j]);
					}
				}

				vm.shots[i].stats.xs = xs;
				vm.shots[i].stats.tens = tens;
				vm.shots[i].stats.nines = nines;
				vm.shots[i].stats.score = shotScore;
				if(vm.shots[i - 1]){
					vm.shots[i].stats.incrementScore = vm.shots[i].stats.score +
						vm.shots[i - 1].stats.incrementScore;
				}else{
					vm.shots[i].stats.incrementScore = vm.shots[i].stats.score;
				}
			}
		};

		function reloadRound(){
			angular.element('#shotInput').focus();
			vm.activeRound = null;
			vm.activeRound = vm.activeMatchPlayer.rounds.find(round =>{
				return round.round === vm.activeRoundIdentifier;
			});
			for(let i = 1; i < vm.maxShots; i++){
				vm.shots[i] = {
					arrows: {
						1: vm.activeRound['arrow_' + i + '_1'],
						2: vm.activeRound['arrow_' + i + '_2'],
						3: vm.activeRound['arrow_' + i + '_3'],
					},
					stats: {
						score: 0,
						incrementScore: 0,
						xs: 0,
						tens: 0,
						nines: 0,
					},
				};
			}
			vm.calculateArrows();
		}

		function reloadMatchData(){
			let data = {include: 'matchPlayers'};
			MatchesFactory.getOne(vm.rootScope.currentMatchId, data).then(response =>{
				vm.matchPlayers = response.data.matchPlayers;
				vm.matchPlayers.sort((a, b) =>{
					if(a.target_name < b.target_name)
						return -1;
					if(a.target_name > b.target_name)
						return 1;
					return 0;
				});
				Object.entries(vm.matchPlayers).forEach(entry =>{
					let value = entry[1].targetNumber;
					if(!vm.targetNumbers.includes(value)){
						vm.targetNumbers.push(value);
					}
				});
				vm.targetNumbers.sort();
				if(vm.activeMatchPlayer){
					let activeMatchPlayerId = vm.activeMatchPlayer.match_player_id;
					vm.activeMatchPlayer = null;
					vm.selectMatchPlayer(activeMatchPlayerId);
				}
			});
		}
	}
}

export default MatchAddShotsController;



// WEBPACK FOOTER //
// ./client/app/components/matches/matchProfile/matchAddShots/matchAddShots.controller.js